import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ShortcutKbd } from "@/components/ui/shortcut-keys";
import { useHasHoverPointer } from "@/hooks/use-device";
import { useIsMac } from "@/hooks/useIsMac";

/**
 * Discoverability affordance for the double-tap-⌥ session switcher: a muted
 * "double-tap and hold ⌥ to switch sessions" subline rendered directly under
 * the "My Sessions" section header ("and hold" because the second press stays
 * held while J/K move the highlight and releasing commits). The keycap keeps its static muted style
 * regardless of the key state (the switcher overlay itself is the feedback
 * for the gesture).
 */
export function SessionSwitcherHint() {
  const $ = _c(7);
  const isMac = useIsMac();
  const hasHoverPointer = useHasHoverPointer();
  if (!hasHoverPointer) {
    return null;
  }
  const keyLabel = isMac ? "\u2325" : "Alt";
  const t0 = `Double-tap and hold ${isMac ? "Option" : "Alt"} to switch sessions`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="type-body-xxs-regular text-neutral-400 dark:text-neutral-500">double-tap and hold</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== keyLabel) {
    t2 = <ShortcutKbd className="h-4 min-w-4 align-text-bottom">{keyLabel}</ShortcutKbd>;
    $[1] = keyLabel;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="type-body-xxs-regular text-neutral-400 dark:text-neutral-500">to switch sessions</span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t0 || $[5] !== t2) {
    t4 = <div aria-label={t0} className="px-3 pb-1.5 leading-4">{t1}{" "}{t2}{" "}{t3}</div>;
    $[4] = t0;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}